var wellKnownSymbol = require('../internals/well-known-symbol');

exports.f = wellKnownSymbol;



//////////////////
// WEBPACK FOOTER
// ./~/react-stickynode/~/core-js/internals/well-known-symbol-wrapped.js
// module id = 461
// module chunks = 0